module.exports = __webpack_public_path__ + "img/orange-bottom-gradient.77697e3a.svg";